import { AppIcon  } from '@/shared/ui/icons'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'

import { Button, Card } from '@/shared/ui'

export const DigitalProductLandingPagesRules = () => {
  return (
    <div
      style={{
        backgroundImage: "url('/misc/bg-go1.jpg')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        backgroundColor: '#914696'
      }}
    >
      <div className="container pb-20">
        <div className="flex flex-col lg:flex-row lg:h-[800px] items-center pt-20">
          <div className="lg:w-5/12 flex flex-col items-start">
            <span className="text-3xl text-white block font-bold pt-20 text-center lg:text-left w-full">
              GAMIFICAÇÃO GO!RN
            </span>
            <span className="text-xl font-bold text-white block mb-4 text-center lg:text-left w-full">
              Inscreva-se no GO!RN, cadastre-se na plataforma gamificada e
              inicie essa jornada!
            </span>
            <Button
              href="https://gamificacao.gorn.com.br/"
              variant="primary"
              className="mx-auto lg:mx-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              Começar!
            </Button>
          </div>
          <div className="lg:w-7/12">
            <img
              src="/misc/pinball-app-mockup-2.png"
              alt=""
              className="block w-full"
            />
          </div>
        </div>

        <div className="my-20">
          <div className="mb-20">
            <span className="text-white font-bold text-3xl text-center block">
              MANUAL DA GAMIFICAÇÃO GO!RN 2023
            </span>
            <span className="text-white font-semibold text-lg text-center block">
              Os seus instrumentos para participar da gamificação serão:
              Passaporte GO!RN e a Plataforma Gamificada.
            </span>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-center">
            <div className="lg:w-5/12">
              <img src="/misc/gamers.png" alt="" className="block w-full" />
            </div>
            <div className="lg:w-1/2">
              <div
                className="w-full flex p-8 text-white mb-10"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
              >
                <div>
                  <span className="block font-bold text-lg mb-2">
                    PASSAPORTE GO!RN
                  </span>
                  <span className="block font-semibold text-sm">
                    Ao se credenciar no evento, você receberá o{' '}
                    <b>Passaporte GO!RN</b>. Esse passaporte faz parte da
                    gamificação e deverá ser usado durante as interações com
                    correalizadores e participação em palestras.
                  </span>
                </div>
              </div>
              <div
                className="w-full flex p-8 text-white"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }}
              >
                <div>
                  <span className="block font-bold text-lg mb-2">
                    PLATAFORMA GAMIFICADA
                  </span>
                  <span className="block font-semibold text-sm">
                    Todos os inscritos no evento recebem um e-mail que os
                    direciona para fazer seu cadastro na plataforma gamificada.
                    Procure na caixa de entrada do e-mail por &quot;GO!RN
                    Gamificação&quot; e siga as instruções.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-20">
          <div className="mb-20">
            <span className="text-white font-bold text-3xl text-center block">
              REGRAS GERAIS DA GAMIFICAÇÃO
            </span>
          </div>
          <div className="flex justify-center">
            <div className="lg:w-10/12">
              <Accordion type="single" collapsible defaultValue="0">
                <AccordionItem value="0">
                  <AccordionTrigger className="py-3 text-left font-bold text-white">
                    Como ganhar carimbos no seu passaporte Pinball Ville do GO!RN?
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="mb-4 text-gray-100 font-semibold text-sm pl-10">
                      <span className="font-bold text-base block mb-3">
                        Cumpra os desafios e as missões especiais para ganhar
                        carimbos no seu Passaporte GO!RN.
                      </span>
                      <span className="block mb-2">
                        1) Participar das palestras dos correalizadores: cada
                        palestra que você assistir lhe dá direito a 1 carimbo do
                        correalizador. Você pode assistir diversas palestras de
                        um mesmo correalizador para acumular carimbos (peça ao
                        monitor da palestra para carimbar).
                      </span>
                      <span className="block mb-2">
                        2) Interagir com os correalizadores: para cada
                        correalizador que visitar e interagir, você ganha 1
                        carimbo (peça ao correalizador para carimbar);
                      </span>{' '}
                      <span className="block mb-2">
                        3) Compartilhar uma foto marcando o correalizador e o
                        GO!RN: faça um post em suas redes sociais, de modo
                        público, marcando os perfis do correalizador e do GO!RN
                        (@gorn.23). Você ganha 1 carimbo para cada post com
                        correalizadores diferentes (mostre o post e solicite o
                        carimbo na Loja GO!RN ou com o correalizador);
                      </span>{' '}
                      <span className="block mb-2">
                        4) Cumpra as missões especiais: para cada missão
                        especial que você cumprir, você ganha 1 carimbo
                        (solicite o carimbo na Loja GO!RN). (ícone loja) Vá até
                        a Loja GO!RN para validar suas missões e realizar a
                        troca dos carimbos em moedas virtuais.
                      </span>
                    </div>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="1">
                  <AccordionTrigger className="py-3 text-left font-bold text-white">
                    Como conseguir recompensas do GO!RN?
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="mb-4 text-gray-100 font-semibold text-sm pl-10">
                      <span className="block mb-2">
                        O GO!RN está repleto de recompensas para a gamificação.
                        Para reservar as recompensas, é necessário acumular
                        moedas virtuais na plataforma gamificada. Cada
                        recompensa custa um número determinado de moedas, assim,
                        para reservar a recompensa, acesse a plataforma, abra a
                        &quot;Lojinha&quot;, selecione a recompensa desejada e
                        clique em &quot;reservar&quot;.
                      </span>
                      <span className="block mb-2">
                        Ao finalizar a reserva, você terá até 60 minutos para
                        retirar a recompensa na LOJA GO!RN. Caso não efetue a
                        retirada, a reserva será cancelada e suas moedas
                        devolvidas.
                      </span>
                    </div>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="2">
                  <AccordionTrigger className="py-3 text-left font-bold text-white">
                    Como adquirir moedas virtuais na Plataforma Gamificada?
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="mb-4 text-gray-100 font-semibold text-sm pl-10">
                      <span className="block mb-2">
                        Cumpra as missões e finalize as Jornadas de Quizzes e
                        Caça ao Tesouro na Plataforma Gamificada para adquirir
                        moedas virtuais.
                      </span>
                      <span className="block mb-4">
                        Você também deve trocar seus carimbos em moedas virtuais
                        para adquirir as recompensas do GO!RN.
                      </span>
                      <div className="flex gap-4">
                        <span className="border p-4 block w-1/2">
                          <span className="text-base mb-3 block">
                            <AppIcon  name="circle-dollar" className="text-white" />{' '}
                            Moeda
                          </span>
                          <span className="block">
                            12 carimbos = 60 moedas virtuais
                          </span>
                          <span className="block">
                            20 carimbos = 100 moedas virtuais
                          </span>
                          <span className="block">
                            30 carimbos = 150 moedas virtuais
                          </span>
                        </span>
                        <span className="border p-4 block w-1/2">
                          <span className="text-base mb-3 block">
                            <AppIcon  name="treasure-chest" className="text-white" />{' '}
                            Loja
                          </span>
                          <span className="block">
                            Solicite a troca dos carimbos em moedas virtuais na
                            Loja GO!RN.
                          </span>
                        </span>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="3">
                  <AccordionTrigger className="py-3 text-left font-bold text-white">
                    Como cumprir os desafios da Plataforma Gamificada?
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="mb-4 text-gray-100 font-semibold text-sm pl-10">
                      <span className="block mb-2">
                        Na nossa plataforma gamificada você responderá a quizzes
                        sobre os espaços do evento e participará da nossa Caça
                        ao Tesouro.
                      </span>
                      <span className="block mb-2">
                        Solucione enigmas, entre no mundo da realidade
                        aumentada, participe das experiências e acumule moedas
                        virtuais para trocar em recompensas do GO!RN.
                      </span>{' '}
                      <span className="block mb-2">
                        Faça seu cadastro no credenciamento e, para dúvidas ou
                        informações, fale com um dos nossos &quot;Suporte da
                        Gamificação&quot;.
                      </span>
                    </div>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="4">
                  <AccordionTrigger className="py-3 text-left font-bold text-white">
                    Como realizar a leitura dos marcadores de Realidade Aumentada?
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="mb-4 text-gray-100 font-semibold text-sm pl-10">
                      <span className="block mb-2">
                        Baixe o aplicativo &quot;Pinball Ville GO!RN&quot; para
                        visualizar os marcadores de realidade aumentada.
                      </span>
                      <span className="block mb-2">
                        Existem diversos marcadores de realidade aumentada
                        espalhados pelo GO!RN. Através do aplicativo, você
                        poderá visualizar todos os personagens de realidade
                        aumentada disponíveis. Basta apontar a câmera do
                        aplicativo para o marcador de realidade aumentada
                        encontrado.
                      </span>
                    </div>
                  </AccordionContent>
                </AccordionItem>

                <AccordionItem value="5">
                  <AccordionTrigger className="py-3 text-left font-bold text-white">
                    Quem pode me dar mais suporte na Gamificação?
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="mb-4 text-gray-100 font-semibold text-sm pl-10">
                      <span className="block mb-2">
                        Fale com um dos &quot;Suportes da Gamificação&quot;, que
                        estão usando colete rosa ou siga diretamente até a LOJA
                        GO!RN.
                      </span>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
